import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Button, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FooterNav from "../FooterNav";
import SliderComponent from "../SliderComponent";
import axios from "axios";
import axiosInstance from "../../AxiosBaseApi";

const Activity = () => {
  const history = useNavigate();
  const [bgColor, setBgColor] = useState(getRandomColor());
  const [data, setData] = useState([
    {
      vip: "VIP1",
      dtask: "Daily Task 1",
      amt: "700.00 per order",
      colors: "#00ffd8",
    },
    {
      vip: "VIP2",
      dtask: "Daily Task 2",
      amt: "2150.00 per order",
      colors: "#4cd964",
    },
    {
      vip: "VIP3",
      dtask: "Daily Task 3",
      amt: "6400.00 per order",
      colors: "#f1c40f",
    },
    {
      vip: "VIP4",
      dtask: "Daily Task 4",
      amt: "9000.00 per order",
      colors: "#7c5284",
    },
  ]);
  const [loading, setLoading] = useState(false); // Track loading state

  const getUserData = async () => {
    try {
      const response = await axios.get(
        "https://taskapi.demovt360.xyz/sst/src/api/api.php?action=plan",
        {
          headers: {
            Accept: "application/json",
          },
          responseType: "json",
        }
      );

      if (response.status === 200) {
        setData(response.data.data);
        setLoading(false); // Set loading to false after data is fetched
      } else {
        alert("Request failed with status: " + response.status);
        setLoading(false); // Also stop loading if the request fails
      }
    } catch (error) {
      console.error("Error during request:", error);
      setLoading(false); // Stop loading if there's an error
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      history("/login");
    } else {
      getUserData();
    }
  }, []);

  const handleBy = async (id) => {
    const userId = localStorage.getItem("mamberId");
    console.log("ff", userId);
    console.log("ff", id);
    try {
      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("plan_id", id);

      const response = await axiosInstance.post("/buy_plan.php", formData);

      if (response.status === 200) {
        alert(response.data.message);
      } else {
        alert("Request failed with status: " + response.status);
      }
    } catch (error) {
      console.error("Error during request:", error);
    }
  };
  function getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  return (
    <>
      <div style={{ width: "100%", marginBottom: "50px" }}>
   
        {/* <Box
          style={{
            height: "8vh",
            display: "flex",
            justifyContent: "space-between",
            background: "rgb(62, 62, 62)",
            alignItems: "center",
            padding: "0 14px",
            borderBottom: "0.7px solid #ff9a8e",
          }}
        >
          <Box onClick={() => history(-1)} style={{ textDecoration: "none" }}>
            <ChevronLeftIcon fontSize="medium" style={{ color: "#fff" }} />
          </Box>
          <Typography variant="body2" color="#fff" ml={2}>
            VIP
          </Typography>
          <Typography
            fontSize={12}
            color="#fff"
            onClick={() => history("/planhistory")}
          >
            history
          </Typography>
        </Box> */}
        <SliderComponent />
        {/* Loader - Display while loading data */}
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }} m={1}>
            {data?.map((datas, ind) => (
              <Box
                key={ind}
                style={{
                  backgroundColor: getRandomColor(),
                  width: "100%",
                  height: "150px",
                  // border: "10px solid #ededed",
                  borderRadius: "10px",
                }}
              >
                <Box
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  
                  <Box
                    style={{
                      display: "flex",
                      width: "100%",
                      // flexWrap: "wrap",
                      flexDirection: "column",
                      justifyContent: "center",
                      // height: "120px",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        // width: "45%",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {/* <Typography variant="subtitle1">Daily Tasks</Typography> */}
                      <Typography
                        variant="h4"
                        style={{ lineHeight: 2, color: "#fff" }}
                      >
                        {datas.level_name}
                    
                      </Typography>
                    </Box>
                                 
                  </Box>
                </Box>
                <Box
                  style={{
                    // justifyContent: "center",
                    // alignItems: "center",
                    display: "flex",
                  }}
                >
                      <Box
                      style={{
                        display: "flex",
                        // width: "45%",
                        flexDirection: "column",
                        // justifyContent: "center",
                        // alignItems: "center",
                        marginLeft:'20px'
                      }}
                    >
                      <Typography variant="body1" style={{ color: "#fff" }}>
                      Task Quantity : {datas.task_quantity}
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{ lineHeight: 1, color: "#fff" }}
                      >
                       
Price Per Unit: {datas.price_per_unit}
                      </Typography>
                    </Box>
                    </Box>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    // borderTop: "1px solid black",
                    margin: "0 15px",
                    padding: 5,
                  }}
                >
                  <Typography
                    style={{
                      color: "#f1c40f",
                      fontSize: 20,
                      fontWeight: 700,
                    }}
                  >
                    {datas.deposit_amount}
                  </Typography>

                  {datas.status === "inactive" ? (
                    <>
                      <Typography
                        style={{
                          padding: "5px 15px",
                          // backgroundColor: "green",
                          color: "#fff",
                          // borderRadius: "12px",
                        }}
                      >
                        Seat is full
                      </Typography>
                    </>
                  ) : (
                    <Button
                      type="button"
                      onClick={() => handleBy(datas.id)}
                      style={{
                        width: "max-content",
                        padding: "15px",
                        height: "24px",
                        lineHeight: "24px",
                        backgroundColor: "#e02d33",
                        color: "#fff",
                        borderRadius: "12px",
                      }}
                    >
                      Join now
                    </Button>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </div>

      <FooterNav />
    </>
  );
};

export default Activity;
